"use client";

import styles from "./styles.module.css";
import { YMaps, Placemark, Map } from "@pbe/react-yandex-maps";

const coords = [52.268093, 104.329484];
export default function InnerMap({
  className,
}: React.HTMLAttributes<HTMLElement>) {
  return (
    <YMaps>
      <Map
        defaultState={{ center: coords, zoom: 12.5, controls: [] }}
        options={{
          suppressMapOpenBlock: true,
        }}
        className={`${styles.map} ${className ? className : ""}`}
        style={{ width: "100%", height: "100%" }}
      >
        <Placemark defaultGeometry={coords} />
      </Map>
    </YMaps>
  );
}

// export default function Map(props: React.HTMLAttributes<HTMLElement>) {
//   return (
//     <YMaps>
//       <InnerMap {...props} />
//     </YMaps>
//   );
// }
